import React from "react";
import { HStack, Text, Flex } from "@chakra-ui/react";
import { parseISO } from "date-fns";
import { Fragments } from "requests";
import { SEX_TO_TITLE } from "../../../../duck";
import { getWeight, getAge } from "../../duck/utils";
import Alert from "../alert";

interface InfoProps {
  patient: Fragments.StoredPatientInfo;
  disclaimerProcedure:
    | Fragments.StoredMedicalCase["disclaimerProcedures"][number]
    | null;
}

const Info: React.FC<InfoProps> = ({ patient, disclaimerProcedure }) => {
  return (
    <Flex wrap="wrap" ml={4} columnGap="6" rowGap={2} align="center">
      <Text fontSize="xl" color="gray.700" fontWeight="bold">
        {patient.name || "-"}
        {disclaimerProcedure && ` (${disclaimerProcedure.title})`}
      </Text>

      <HStack spacing={2}>
        <Text color="gray.500" fontWeight="semibold">
          Age:
        </Text>
        <Text color="gray.700" fontWeight="bold">
          {getAge(patient.dateOfBirth ? parseISO(patient.dateOfBirth) : null)}
        </Text>
      </HStack>

      <HStack spacing={2}>
        <Text color="gray.500" fontWeight="semibold">
          Sex:
        </Text>
        <Text color="gray.700" fontWeight="bold">
          {patient.sex ? SEX_TO_TITLE[patient.sex] : "-"}
        </Text>
      </HStack>

      <HStack spacing={2}>
        <Text color="gray.500" fontWeight="semibold">
          Weight:
        </Text>
        <Text color="gray.700" fontWeight="bold">
          {getWeight(patient.weight || null, patient.weightMeasure)}
        </Text>
      </HStack>

      {patient?.alerts ? <Alert label={patient.alerts} /> : null}
    </Flex>
  );
};

export default Info;
